import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFile as UploadFileIcon } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';

interface FileUploadFieldProps {
  label: string;
  error?: string;
  value: File | null;
  onChange: (file: File | null) => void;
  required?: boolean;
}

export function FileUploadField({
  label,
  error,
  value,
  onChange,
  required,
}: FileUploadFieldProps) {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <TextField
      fullWidth
      required={required}
      label={label}
      value={value?.name ?? ''}
      placeholder={t('onboarding.fileUploadPlaceholder')}
      error={Boolean(error)}
      helperText={error}
      onClick={() => fileInputRef.current?.click()}
      InputProps={{
        readOnly: true,
        sx: { cursor: 'pointer' },
        endAdornment: (
          <InputAdornment position="end">
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
              <input
                ref={fileInputRef}
                type="file"
                hidden
                accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
                onChange={(e) => {
                  const f = e.target.files?.[0] ?? null;
                  onChange(f);
                  e.target.value = '';
                }}
              />
              <IconButton
                type="button"
                color="primary"
                aria-label={t('onboarding.uploadAriaLabel', { label })}
                edge="end"
                onClick={(e) => {
                  e.stopPropagation();
                  fileInputRef.current?.click();
                }}
              >
                <UploadFileIcon />
              </IconButton>
            </Box>
          </InputAdornment>
        ),
      }}
    />
  );
}
